import React, { useState, useEffect } from 'react';
import VehicleCard from 'components/Cards/VehicleCard';
import ToggleDetail from 'components/ToggleDetail';
import VehicleFormWrapper from 'components/Forms/VehicleFormWrapper';
import { get } from 'services';
import { connect } from 'react-redux';
import Alerts from 'utils/alerts'
import Spinner from 'react-bootstrap/Spinner'
import Navigation from "components/Navigation";
import ValidateToken from "components/ValidToken";

const VehicleModule = ({user}) => {
  const [showDetail, setShowDetail] = useState(true);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true);
        const response = await get(`PersonaVehiculo/GetByPersonaId/${user.persona.id}`);
        if (response && response.data.length > 0) {
          setShowDetail(true);
        } else {
          setShowDetail(false);
        }
        setData(response.data);
      } catch (error) {
        Alerts.operationFail();
      } finally {
        setIsLoading(false);
      }
    })();
  }, [])

  return (
    <>
      <ValidateToken/>
      <div className={''}>
        {
            isLoading &&
            <div className={'display-flex flex-direction-row flex-center'}>
                <Spinner 
                  animation="grow" 
                  variant="primary" 
                  className={'is-absolute center-spinner-vertically'} 
                  size="lg" />
            </div>
          }
        <ToggleDetail initState={showDetail} onToggleDetail={setShowDetail} label="Vehículo"/>
        { 
          showDetail ? 
          <div> 
            <VehicleCard data={data} />
            <br/>
            <Navigation beforeUrl="/familyStructure" continueUrl="/education" />
          </div>
          : 
          <div> 
            <VehicleFormWrapper data={data} />
          </div>
        }
      </div>
    </>
  )
}


const mapStateToProps = (state) => {
  return {
      user: state.user
  }
}

export default connect(mapStateToProps)(VehicleModule);